module.exports = __webpack_public_path__ + "img/TV_clean_box06.90d97f14.jpg";